<template>
	<div id="meeting" style="min-width: 1000px;">
		<div class="container">
			<!-- <div class="companyInfo">
				<div class="company_avatar">
					<img v-if="schoolInfo.logo" :src="schoolInfo.logo"></img>
					<div class="company_name" v-else>
						{{schoolInfo.company_name?schoolInfo.company_name.substring(0,1):''}}
					</div>
				</div>
				<div class="companyInfoRight">
					<div class="companyInfoName">
						{{ schoolInfo.company_name || '校招平台用户' }}
					</div>
					<div class="tags">
						<div class="item" v-if="schoolInfo.industry">
							{{schoolInfo.industry || ''}}
						</div>
						<div class="item" v-if="schoolInfo.scale">
							{{schoolInfo.scale || ''}}
						</div>
					</div>
				</div>
			</div> -->

			<div class="sortContainer" style="background: #fff;">
				<div class="applyContainer">
					
					<div class="item" @click="toJobShadowing">
						<div class="left">
							<div class="title">
								百万学生探岗报名
							</div>
							<div class="subheading">
								<div class="">
									查看详情
								</div>
								<img src="../img/more5.png" alt="" />
							</div>
						</div>
						<div class="right">
							<img src="../img/applyImg3.png" alt="" style="width: 42px;height: 40px;" />
						</div>
					</div>
					
					<div class="item" style="background:#EAF0FC;" @click="toWednesday">
						<div class="left">
							<div class="title">
								周三名企宣讲报名
							</div>
							<div class="subheading">
								<div class="">
									查看详情
								</div>
								<img src="../img/more5.png" alt="" />
							</div>
						</div>
						<div class="right">
							<img src="../img/applyImg2.png" style="width: 35px;height: 40px;" alt="" />
						</div>
					</div>
					
					<div class="item" style="background:#FBF1E5;" @click="corporateApply">
						<div class="left">
							<div class="title">
								10号万企对接报名
							</div>
							<div class="subheading">
								<div class="">
									查看详情
								</div>
								<img src="../img/more5.png" alt="" />
							</div>
						</div>
						<div class="right">
							<img src="../img/applyImg1.png" style="width: 46px;height: 40px;" alt="" />
						</div>
					</div>

				</div>


				<div class="screenContainer">
					<div class="searchContainer">
						<div class="screenItem" style="margin-top: 6px;">
							<div class="left">
								省份
							</div>
							<div class="item" :class="majors[0].isSelect ?'active':''" @click="selectProvince(0)">
								全部
							</div>
							<div class="right">
								<div class="item" :class="item.isSelect?'active':''" @click="selectProvince(index)"
									v-for="(item,index) in majors" :key='index' v-if="index>0">
									{{item.name}}
								</div>
							</div>
						</div>

						<div class="screenItem">
							<div class="left">
								层次
							</div>
							<div class="right">
								<div class="item" :class="item.isSelect?'active':''" @click="selectgradation(index)"
									v-for="(item,index) in gradation" :key='index'>
									{{item.name}}
								</div>
							</div>
						</div>

						<!-- <div class="screenItem">
							<div class="left">
								费用
							</div>
							<div class="right">
								<div class="item" :class="item.isSelect?'active':''" @click="selectexpense(index)"
									v-for="(item,index) in expense" :key='index'>
									{{item.name}}
								</div>
							</div>
						</div>

						<div class="screenItem">
							<div class="left">
								类型
							</div>
							<div class="right">
								<div class="item" :class="item.isSelect?'active':''" @click="selecttypeList(index)"
									v-for="(item,index) in typeList" :key='index'>
									{{item.name}}
								</div>
							</div>
						</div> -->
					</div>

					<div class="" style="display: flex;flex-direction: column;justify-content: space-between;">
						<div class="" style="display: flex;">
							<div class="btnContainer" style="margin-right: 10px;">
								<div class="searchLeft">
									<img src="../img/search2.png" alt="" />
									<input type="text" v-model="searchName" placeholder-style="color:red"
										placeholder="学校/双选会名称" />
								</div>
								<div class="btn" @click="search">
									<div style="font-weight: 600;">搜索</div>
								</div>
							</div>
							<div class=""
								style="background: #1E40AF;margin-left: 0;width: 100px;height: 39px;display: flex;align-items: center;justify-content: center;border-radius: 5px;font-size: 0;cursor: pointer;"
								@click="postPosition">
								<div style="font-weight: 400;font-size: 14px;color: #ffffff;">
									我的报名{{regLength?'·'+regLength:''}}
								</div>
							</div>
						</div>

						<div class="" style="display: flex;justify-content: flex-end;align-items: center;">
							<div class="" style="color: #333;font-size: 14px;margin-right: 10px;">
								按线路选择
							</div>
							<el-switch
							  v-model="isApply"
							  @change='applyChange'
							  active-color="#1E40AF"
							  >
							</el-switch>
						</div>
					</div>




				</div>
			</div>
			<!-- <div class="sortContainer" style="position: fixed;top: 56px;z-index: 100;background: #fff;">
				<div class="screenContainer">
					<div class="searchContainer">
						<div class="searchItem">
							<div class="iptName">类型：</div>
							<el-select @change="changeMeeting" v-model="headIndex" placeholder="请选择类型">
								<el-option v-for="item in typeList" :key="item.value" :label="item.label"
									:value="item.value"> </el-option>
							</el-select>
						</div>
						<div class="searchItem">
							<div class="iptName iptName1">省份：</div>
							<div class="majorbox" @click="selectcityBox3">
								<div class="majorBox one-line"
									:style="academy_feature.length > 0 ? '' : 'color:#c0c4cc;'">
									{{ academy_feature.length > 0 ? academy_feature.join('，') : '请选择省份' }}
								</div>
								<i class="el-icon-arrow-down" style="color: #c0c4cc"></i>
							</div>
						</div>
						<div class="searchItem">
							<div class="iptName iptName1">学校层次：</div>
							<el-select v-model="education" @change="changeMeetingLevel" placeholder="学校层次">
								<el-option v-for="(item, index) in eduList" :key="index" :label="item" :value="item">
								</el-option>
							</el-select>
						</div>
						<div class="searchItem">
							<div class="iptName iptName1">收费：</div>
							<el-select v-model="isFree" @change="changeIsFree" placeholder="收费">
								<el-option v-for="(item, index) in freeList" :key="index" :label="item" :value="item">
								</el-option>
							</el-select>
						</div>
					</div>

					<div class="" style="display: flex;align-items: center;">
						<div class="btnContainer" style="margin-right: 10px;">
							<div class="searchLeft">
								<img src="../img/search2.png" alt="" />
								<input type="text" v-model="searchName" placeholder-style="color:red"
									placeholder="搜索双选会名称" />
							</div>
							<div class="btn" @click="search">
								<div>搜索</div>
							</div>
						</div>
						<div class=""
							style="background: #1E40AF;margin-left: 10px;width: 100px;height: 39px;display: flex;align-items: center;justify-content: center;border-radius: 5px;font-size: 0;cursor: pointer;"
							@click="postPosition">
							<div style="font-weight: 400;font-size: 14px;color: #ffffff;">
								我的报名{{regLength?'·'+regLength:''}}
							</div>
						</div>
					</div>
				</div>
			</div> -->
			<!-- <img src="https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2026/05/14/pw0ripxuach24v7e.png"
				style="width:90px; height:72px;"
				alt="双选会海报"> -->


			<div class="listContainer">
				<!-- <div class="title">
					生源列表
				</div> -->
				<!-- <div class="" style="width: 100%;height: 113px;">

				</div> -->

				<div class="tableContainer"  v-loading="loading">
					<!-- <ul class="infinite-list" v-infinite-scroll="load" infinite-scroll-immediate='false' style="overflow:auto;height: 602px;"> -->

					<div class="tableHeader" style="border: 1px solid #e9eeff;position: sticky;top: 0;z-index: 100;">
						<div class="" style="width: 50px;">
							<!-- <el-checkbox v-model="allChecked" @change='allSelect' v-if="isApply"></el-checkbox> -->
						</div>
						<div class="" style="width: 370px;">
							千校招聘线路
						</div>
						<div class="" style="flex: 1;">
							举办时间
						</div>
						<div class="" style="width: 100px;">
							举办形式
						</div>
						<div class="" style="flex: 1;">
							报名截止
						</div>
						<div class="" style="width: 90px;">
							费用
						</div>
						<div class="" style="width: 120px;">
							操作
						</div>
					</div>
					<div class="tableBody"  style=""  v-if="meetlist.length>0">
						<div class="" v-for="(item,index) in meetlist" :key="index" >
						<div class="">
							
						</div>
						<div class="" style="display: flex;align-items: center;padding: 10px 0 10px 20px; " v-if="isApply">
							<el-checkbox v-model="item.isSelect" :disabled="selectable2(item,index)" @change='someSelect(index,item)' ></el-checkbox>
							<div class="" style="color: #333;font-size: 16px;margin-left: 10px;font-weight: 600;">
								{{item.line_name}}
							</div>
						</div>
						<div class="" style="border-radius: 10px;" :style="isApply?'border: 1px solid #d1d2f1;':'border: 1px solid #f9fbff;'">
							<div class="" v-for="(itm,idx) in item.list" :key="idx">
							<div class="" style="display: flex;align-items: center;" >
								<div class="checkboxContainer item" style="width: 50px;" >
									<el-checkbox v-model="itm.isSelect" :disabled="selectable1(itm,idx)" @change='itemSelect(item,index,itm,idx)' ></el-checkbox>
								</div>
								<div class="jobfairname item" style="width: 370px;">
									<img :src="itm.meeting_cover_img+'?x-oss-process=image/format,jpg/quality,q_75'"
										alt="" />
									<div class="item-right" style="display: flex;align-items: center;">
										<div class="item-1 " :title="itm.meeting_short_name">
											{{ itm.meeting_short_name }}
										</div>
									</div>
								</div>
								<div class="holdingTime item" style="flex: 1;justify-content: center;">
									{{ itm.meeting_time}} {{itm.meeting_hour}}
								</div>
								<div class="assemblyRoom item" style="width: 100px;justify-content: center;">
									<div class="" style="display: flex;align-items: center;justify-content: center;">
										<div class="meettype" style=";cursor: pointer;color: #1E40AF;font-weight: 600;" @click="handleQrcode(itm)">
											线上</div>
										<div class="meettype"
											style="color: #1E40AF;font-weight: 600;margin-left: 2px;margin-right: 2px;">
											+ </div>
										<el-tooltip class="" effect="dark" content="暂未公布会场展位图！"
											placement="bottom-start">
											<div class="meettype"
												style="cursor: pointer;color: #1E40AF;font-weight: 600;" @click="offline(itm)">
												线下</div>
										</el-tooltip>
									</div>
								</div>
								<div class="cutOff item" style="flex: 1;justify-content: center;">
									
									<div class="deadline" v-if="itm.meeting_status !=5">
										<div class="deadline" style="font-weight: 600;"
											v-if="(itm.meeting_status == 1)&&!itm.reg_end_time">
											报名中 {{ itm.sDay > 0 ? '剩' + itm.sDay + '天' : '' }}
										</div>
										<div class="deadline" style="font-weight: 600;"
											v-if="itm.meeting_status == 2">
											报名结束
										</div>
										<div class="deadline" style="font-weight: 600;"
											v-if="(itm.meeting_status == 6||itm.meeting_status == 4||itm.meeting_status == 1)&&itm.reg_end_time">
											{{itm.reg_end_time}}
										</div>
									</div>
									<div class="deadline" v-else>-</div>
									
								</div>
								<div class="cost item" style="width: 90px;justify-content: center;">
									<el-button class="payFees"
										:style="itm.meeting_status==6&&itm.website!=''?'text-decoration: underline;color: #0000EE;cursor:pointer;font-weight: 600;':'font-weight: 600;'"
										v-if="itm.meeting_price&&itm.meeting_price!='0'"
										@click="towebsite1(itm)" type="primary">
										{{itm.meeting_status==6&&itm.website!=''?'去官网缴费':''}}{{itm.meeting_price}}元</el-button>
									<el-button style="font-weight: 600;" class="payFees payFees1" v-else
										type="primary">免费</el-button>
								</div>
								<div class="cost item" style="width: 120px;justify-content: center;">
									<el-button class="compile" v-if="itm.meeting_status == 0" @click="toSign(itm)"
										type="primary">{{itm.meeting_status_name }}</el-button>
									<el-button class="compile"
										v-if="itm.meeting_status == 1||itm.meeting_status == 6"
										@click="toSign(itm)" :style="itm.registered?'opacity: 0.4':''"
										type="primary">{{itm.registered?'已报名':'去报名'}}</el-button>
									<el-button class="compile" v-if="itm.meeting_status == 2"
										@click="handleClick1(itm)" type="primary">去报名</el-button>
									
									<el-button class="compile"
										v-if="itm.meeting_status == 3||itm.meeting_status == 4"
										style="opacity: 0.4" type="primary">{{itm.meeting_status_name}}</el-button>
									
									<el-button class="compile" v-if="itm.meeting_status == 5" type="primary"
										@click="towebsite(itm)">官网报名</el-button>
									
								</div>
								
								
							</div>
							<div class="" style="border-bottom: 1px solid #EBEEF5;margin-left: 60px;margin-right: 20px;" v-if="item.list.length-1>idx">
								
							</div>
							</div>
						</div>
						
						</div>
					</div>
					
					<div class="" v-else>
						<el-empty description="暂无双选会" slot="empty"></el-empty>
					</div>
					
					



					<!-- <el-table header-row-class-name="header-row-class-name" :data="meetlist" style="width: 100%;"
						v-loading="loading" ref="multipleTable" @select="handleSelectionChange"
						:row-class-name="tableRowClassName" @select-all='selectAll' height="calc(100vh - 280px)">

						<el-empty description="暂无双选会" slot="empty"></el-empty>

						<el-table-column type="selection" width="55" disabled :selectable='selectable'>
						</el-table-column>

						<el-table-column prop="job_type" label="双选会名称" width="370">
							<template slot-scope="scope">
								<div class="item-main-box">

									<img :src="scope.row.meeting_cover_img" alt="" />
									<div class="item-right" style="display: flex;align-items: center;">
										<div class="item-1 " :title="scope.row.meeting_short_name">
											{{ scope.row.meeting_short_name }}
										</div>
									</div>
									
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="salary" label="举办时间">
							<template slot-scope="scope">
								<div class="holdingTime">
									<div class="" style="font-weight: 600;">
										{{ scope.row.meeting_time}} {{scope.row.meeting_hour}}
									</div>
									
								</div>
							</template>
						</el-table-column>

						<el-table-column prop="job_name" label="会场" width="100">
							<template slot-scope="scope">
								<div class="" style="display: flex;align-items: center;justify-content: center;">
									<div class="meettype" style=";cursor: pointer;color: #1E40AF;font-weight: 600;w"
										@click="handleQrcode(scope.row)">线上</div>
									<div class="meettype"
										style="color: #1E40AF;font-weight: 600;margin-left: 2px;margin-right: 2px;">
										+ </div>

									<div class="meettype" style="cursor: pointer;color: #1E40AF;font-weight: 600;"
										v-if="scope.row.stand_position_url" @click="offline(scope.row)">线下</div>

									<el-tooltip class="item" effect="dark" content="暂未公布会场展位图！" placement="bottom-start"
										v-else>
										<div class="meettype" style="cursor: pointer;color: #1E40AF;font-weight: 600;">
											线下</div>
									</el-tooltip>

								</div>
							</template>
						</el-table-column>

						
						<el-table-column prop="job_end_time" label="报名截止">
							<template slot-scope="scope">
								<div class="deadline" v-if="scope.row.meeting_status !=5">
									<div class="deadline" style="font-weight: 600;"
										v-if="(scope.row.meeting_status == 1)&&!scope.row.reg_end_time">
										报名中 {{ scope.row.sDay > 0 ? '剩' + scope.row.sDay + '天' : '' }}
									</div>
									<div class="deadline" style="font-weight: 600;"
										v-if="scope.row.meeting_status == 2">
										报名结束
									</div>
									<div class="deadline" style="font-weight: 600;"
										v-if="(scope.row.meeting_status == 6||scope.row.meeting_status == 4||scope.row.meeting_status == 1)&&scope.row.reg_end_time">
										{{scope.row.reg_end_time}}
									</div>
								</div>
								<div class="deadline" v-else>-</div>
							</template>
						</el-table-column>
						

						<el-table-column prop="job_end_time" label="费用" width="90">
							<template slot-scope="scope">
								<el-button class="payFees"
									:style="scope.row.meeting_status==6&&scope.row.website!=''?'text-decoration: underline;color: #0000EE;cursor:pointer;font-weight: 600;':'font-weight: 600;'"
									v-if="scope.row.meeting_price&&scope.row.meeting_price!='0'"
									@click="towebsite1(scope.row)" type="primary">
									{{scope.row.meeting_status==6&&scope.row.website!=''?'去官网缴费':''}}{{scope.row.meeting_price}}元</el-button>
								<el-button style="font-weight: 600;" class="payFees payFees1" v-else
									type="primary">免费</el-button>
							</template>
						</el-table-column>

						<el-table-column label="操作" width="120">
							<template slot-scope="scope">

								<el-button class="compile" v-if=" scope.row.meeting_status == 0" @click="toSign(scope)"
									type="primary">{{ scope.row.meeting_status_name }}</el-button>
								<el-button class="compile"
									v-if="scope.row.meeting_status == 1||scope.row.meeting_status == 6"
									@click="toSign(scope)" :style="scope.row.registered?'opacity: 0.4':''"
									type="primary">{{scope.row.registered?'已报名':'去报名'}}</el-button>
								<el-button class="compile" v-if="scope.row.meeting_status == 2"
									@click="handleClick1(scope.row)" type="primary">去报名</el-button>

								<el-button class="compile"
									v-if="scope.row.meeting_status == 3||scope.row.meeting_status == 4"
									style="opacity: 0.4" type="primary">{{ scope.row.meeting_status_name }}</el-button>

								<el-button class="compile" v-if="scope.row.meeting_status == 5" type="primary"
									@click="towebsite(scope.row)">官网报名</el-button>


							</template>
						</el-table-column>
					</el-table> -->
					
					<div class="paging" style="justify-content: flex-end;" v-if="meeting_num>0">
						<div class="" style="display: flex;align-items: center;">
							<!-- <div class="pagingLeft">

								<el-button @click="previousPage" :disabled='currentpage > 1?false:true'>上一页</el-button>
								<el-button @click="nextPage" :disabled='isNextPage'>下一页</el-button>
							</div> -->
							<div class="" style="font-size: 14px;color: #333;font-weight: 600;">
								已选中 <span style="color:#1E40AF;">{{meeting_num}}</span> 场，总费用 <span style="color:#1E40AF;">{{meeting_price}}</span> 元
							</div>
							<div class="right" style="display: flex;align-items: center;margin-left:10px;">
								
								<el-button type="primary" class="signAll"
									:style="meeting_num==0?'opacity: 0.5;':''" 
									:disabled='meeting_num==0'
									@click="signAll1">批量报名{{meeting_num==0?'':'·'+meeting_num}}</el-button>
								
							</div>
						</div>
						<!-- <el-pagination background layout="total,sizes,prev, pager, next" :page-sizes="[10, 20, 50]"
							:total="total" @current-change="currentChange" @size-change="handleSizeChange"
							:current-page="currentpage"> </el-pagination> -->
					</div>
					

				</div>
				

				

					
				<div class="" style="width: 100%;height: 55px;">
					
				</div>
			</div>
		</div>

		<div class="preview">
			<el-dialog :visible.sync="dialogVisible" :show-close="false" width="550px">
				<div class="elDialog">
					<img class="close" @click="closeElDialog" src="../img/close.png" alt="" />
					<div class="main">
						<div class="title">会场二维码</div>
						<div class="qrcodeContainer">
							<div class="qrcode">
								<img :src="qrcodeImg || 'https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2026/05/13/dj8ukf7j9xlmlc5a.jpg'"
									alt="" />

								<div class="hite1">扫二维码进入线上会场</span></div>
								<!-- <div class="hite2">扫码识别二维码进入线上会场</div> -->
							</div>
						</div>
					</div>
				</div>
			</el-dialog>
		</div>

		<div class="preview">
			<el-dialog :visible.sync="dialogVisible1" :show-close="false" width="500px">
				<div class="elDialog">
					<img class="close" @click="closeElDialog1" src="../img/close.png" alt="" />
					<div class="main">
						<div class="title">双选会预览</div>
						<div class="qrcodeContainer">
							<div class="qrcode">
								<img :src="qrcodeImg1" alt="" v-if='qrcodeImg1' />

								<div class="hite1">扫二维码进入线上会场</div>
								<div class="hite2">可在手机上预览双选会</div>
							</div>
						</div>
					</div>
				</div>
			</el-dialog>
		</div>


		<el-dialog title="批量导入" :visible.sync="importData" :before-close="beforeClose" width="800px">
			<div class="">
				<!-- <div class="iptContainer">
					<div class="item">
						<div class="itemTitle">
							身份:
						</div>
						<div class="">
							<el-select v-model="identity" placeholder="请选择">
								<el-option v-for="(item,index) in options1" :key="index" :label="item.label"
									:value="item.value">
								</el-option>
							</el-select>
						</div>
					</div>
					<div class="item">
						<div class="itemTitle">
							对接类型:
						</div>
						<div class="">
							<el-select v-model="type" placeholder="请选择">
								<el-option v-for="item in options2" :key="item.value" :label="item.label"
									:value="item.value">
								</el-option>
							</el-select>
						</div>
					</div>
					<div class="item">
						<div class="itemTitle">
							来源:
						</div>
						<div class="">
							<el-select v-model="source" placeholder="请选择">
								<el-option v-for="item in options4" :key="item.value" :label="item.label"
									:value="item.value">
								</el-option>
							</el-select>
						</div>
					</div>
		
				</div> -->

				<div>
					<!-- :data='fileData1' -->
					<el-upload class="upload-demo" drag action="http://114.215.204.153:8089/jobinfo/doBatchImport"
						:on-success="handleAvatarSuccess1" :before-upload="beforeUpload" :show-file-list="false">
						<i class="el-icon-upload"></i>
						<div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
						<!-- <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过500kb</div> -->
					</el-upload>
					<div class="" v-html="resmessage"></div>
				</div>
			</div>
		</el-dialog>
		<!-- <el-dialog title="双选会省份" ref="multipleChoice3" :visible.sync="dialogVisibleMultipleChoice4"
			:before-close="handleClose" @open="multipleOpen" @close="multipleClose" width="800px">
			<multipleChoice10 @searchWord="searchWord" @submit="multiple4" @cancel="cancel"
				:searchList="college_type_list" :selectList="academy_feature" :multipleChange="multipleChange">
			</multipleChoice10>
		</el-dialog> -->
	</div>
</template>
<script>
	import {
		mapMutations,
		mapState
	} from 'vuex'
    const config = require('../../WebConfig')
	// import multipleChoice10 from '../components/multipleChoice10.vue'
	export default {
		components: {
			// multipleChoice10,
		},
		data() {
			return {
				expense: [{
					name: '全部',
					isSelect: true
				}, {
					name: '收费',
					isSelect: false
				}, {
					name: '免费',
					isSelect: false
				}],

				gradation: [{
					name: '全部',
					isSelect: true
				}, {
					name: '双一流',
					isSelect: false
				}, {
					name: '本科',
					isSelect: false
				}, {
					name: '高职高专',
					isSelect: false
				}],

				typeList: [{
					name: '全部',
					isSelect: true
				}, {
					name: '线上',
					isSelect: false
				}, {
					name: '线下',
					isSelect: false
				}],
				academy_feature: [],
				majors: [{
						name: '全部',
						isSelect: true
					}, {
						name: '北京',
						isSelect: false
					},
					{
						name: '江苏',
						isSelect: false
					},
					{
						name: '上海',
						isSelect: false
					},
					{
						name: '广东',
						isSelect: false
					},

					{
						name: '湖北',
						isSelect: false
					},
					{
						name: '陕西',
						isSelect: false
					},
					{
						name: '四川',
						isSelect: false
					},
					{
						name: '浙江',
						isSelect: false
					},

					{
						name: '山东',
						isSelect: false
					},
					{
						name: '辽宁',
						isSelect: false
					},
					{
						name: '湖南',
						isSelect: false
					},
					{
						name: '安徽',
						isSelect: false
					},

					{
						name: '天津',
						isSelect: false
					},
					{
						name: '重庆',
						isSelect: false
					},
					{
						name: '福建',
						isSelect: false
					},
					{
						name: '河南',
						isSelect: false
					},

					{
						name: '黑龙江',
						isSelect: false
					},
					{
						name: '吉林',
						isSelect: false
					},
					{
						name: '河北',
						isSelect: false
					},
					{
						name: '江西',
						isSelect: false
					},

					{
						name: '广西',
						isSelect: false
					},
					{
						name: '山西',
						isSelect: false
					},
					{
						name: '云南',
						isSelect: false
					},
					{
						name: '贵州',
						isSelect: false
					},

					{
						name: '甘肃',
						isSelect: false
					},
					{
						name: '新疆',
						isSelect: false
					},
					{
						name: '内蒙古',
						isSelect: false
					},
					{
						name: '海南',
						isSelect: false
					},
					{
						name: '宁夏',
						isSelect: false
					}, {
						name: '青海',
						isSelect: false
					}, {
						name: '西藏',
						isSelect: false
					}
				],
				multipleChange: false,
				dialogVisibleMultipleChoice4: false,
				searchName: '',
				meetlist: [],
				dialogVisible: false,
				shcool_level: '',
				headIndex: '',
				options: [{
						value: '男',
						label: '男',
					},
					{
						value: '女',
						label: '女',
					},
				],
				value: '',
				value1: '',

				total: 0,
				pageSizes: 10,
				currentPage: 1,
				currentpage: 1,

				pickerOptions: {
					disabledDate(time) {
						return time.getTime() < Date.now()
					},
				},
				jobList: [],
				tableData: [{
						date1: '全职',
						date2: 'UI设计师',
						date3: '8000-10000',
						date4: '本科',
						date5: '2',
						date6: '08:30-17:30',
						date7: '2025-01-12',
						date8: '双休',
						date9: '偶尔加班',
						date10: '偶尔出差',
						date11: '预览职位',
					},
					{
						date1: '全职',
						date2: 'UI设计师',
						date3: '8000-10000',
						date4: '本科',
						date5: '2',
						date6: '08:30-17:30',
						date7: '2025-01-12',
						date8: '双休',
						date9: '偶尔加班',
						date10: '偶尔出差',
						date11: '预览职位',
					},
					{
						date1: '全职',
						date2: 'UI设计师',
						date3: '8000-10000',
						date4: '本科',
						date5: '2',
						date6: '08:30-17:30',
						date7: '2025-01-12',
						date8: '双休',
						date9: '偶尔加班',
						date10: '偶尔出差',
						date11: '预览职位',
					},
					{
						date1: '全职',
						date2: 'UI设计师',
						date3: '8000-10000',
						date4: '本科',
						date5: '2',
						date6: '08:30-17:30',
						date7: '2025-01-12',
						date8: '双休',
						date9: '偶尔加班',
						date10: '偶尔出差',
						date11: '预览职位',
					},
				],
				regLength: 0,

				// typeList: [{
				// 		value: '',
				// 		label: '精选双选会',
				// 	},
				// 	{
				// 		value: '1',
				// 		label: '线下双选会',
				// 	},
				// 	{
				// 		value: '2',
				// 		label: '空中双选会',
				// 	},
				// ],
				// job_type 招聘类型 1校招2实习3兼职
				// salary_min 薪资最小值   示例：5
				// salary_max 薪资最大值  示例：7
				// education 学历要求  json数组，格式如：["博士","本科"]
				// job_num 招聘人数   示例：2
				// end_time_st 截止时间开始  格式如2025-01-01
				// end_time_et 截止时间结束  格式如2025-01-01

				selectList: [],
				eduList: ['全部', '双一流', '本科', '高职高专'],
				freeList: ['不限', '是', '否'],
				isFree: '不限',
				statusList: ['全部', '报名中', '进行中', '已结束'],
				salaryArry1: [],
				salaryArry2: [],
				salaryArry3: [],

				job_type: '', //招聘类型
				education: '', //学历要求

				meetingStatus: '', //双选会状态
				job_num: '', //招聘人数
				end_time_et: '', //截止时间
				salary_min: '',
				salary_max: '',

				isshow: false,
				salaryDisabled: true,
				qrcodeImg: '',

				loading: false,
				importData: false,

				searchObj: {},
				resmessage: '',

				dialogVisible1: false,
				qrcodeImg1: '',
				isnextPage: false,

				page: 1,

				selectMeetList: [],


				idList: [],

				num: 0,
				meetingALLPrice: 0,

				selectMeetList1: [],
				request: false,

				meeting_id: '',
				is_demo: 1,
				searchName1: '',

				timer: null,


				isApply: true,



				checked: false,
				
				
				allChecked:false,
				
				
				selectMeetList1:[],
				
				meeting_num:0,
				
				meeting_price:0,
				selectIds:[],
				
				
				selectList1:[],
			}
		},
		watch: {
			nextToken(val) {
				console.log(val)
				this.regLength = 0
			}
		},
		filters: {
			jobType(val) {
				switch (val) {
					case 1:
						return '全职'
					case 2:
						return '实习'
					case 3:
						return '兼职'
					default:
						return '全职'
				}
			},
			salary(val) {
				if (val) {
					return val
				} else {
					return '面议'
				}
			},
		},
		mounted() {
			if (!this.nextToken) {
				sessionStorage.setItem('ismeet', 1)
			} else {
				sessionStorage.removeItem('ismeet')
			}
			if (this.$route.query.id) {
				this.meeting_id = this.$route.query.id.replace('meetid', '')
			}
			if (this.$route.query.demo) {
				this.is_demo = this.$route.query.demo
				sessionStorage.setItem('demo', this.$route.query.demo)
			}
			if (sessionStorage.getItem('demo')) {
				// this.is_demo = sessionStorage.getItem('demo')
			}


			this.getmyJobList()
			this.getMySchoolMeeting()
			// this.getQrcode()
			let arr = [{
				label: '面议',
				value: 0,
			}, ]
			for (let i = 1; i < 31; i++) {
				arr.push({
					label: i + 'K',
					value: i,
				})
			}
			for (let i = 1; i < 15; i++) {
				arr.push({
					label: 30 + i * 5 + 'K',
					value: 30 + i * 5,
				})
			}
			for (let i = 1; i < 16; i++) {
				arr.push({
					label: 100 + i * 10 + 'K',
					value: 100 + i * 10,
				})
			}
			this.salaryArry1 = arr
			this.salaryArry2 = arr
			this.salaryArry3 = arr
			// this.$util.post(
			// 	"/login/login", {
			// 		username: this.ruleForm.username,
			// 		password: this.$md5(this.ruleForm.pass),
			// 	},
			// 	(res) => {
			//
			// 		if (res.code == 1) {
			// 			localStorage.setItem("token", res.data.token);
			// 			this.$router.push({
			// 				path: "/main",
			// 				// query: {
			// 				//   id: 1,
			// 				// },
			// 			});
			// 		}
			// 	}
			// );
		},
		computed: {
			...mapState({
				nextToken: (state) => state.nextToken,
				userInfo: (state) => state.userInfo,
				schoolInfo: (state) => state.schoolData,
			}),

			isNextPage() {
				// total
				// pageSizes
				// currentpage
				console.log(this.currentpage)
				console.log(Math.ceil(this.total / this.pageSizes))
				if (this.currentpage == Math.ceil(this.total / this.pageSizes) || Math.ceil(this.total / this.pageSizes) ==
					0) {
					return true
				} else {
					return false
				}
			}
		},
		methods: {
			...mapMutations(['setIslogin']),
			corporateApply(){
				if (!this.nextToken) {
					this.$confirm('使用完整功能，请登录使用！', '提示', {
						confirmButtonText: '去登录',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.$router.push({
							path: '/login',
							// query: {
							//   id: 1,
							// },
						})
					}).catch(() => {
				
					});
					return
				}
				this.$router.push({
					path: '/corporateApply',
				})
			},
			// 二维数组展开
			flatTree(arr) {
			  const groupRecord = [] // 记录每组子数组长度
			  const flatItems = []
			  arr.forEach(item => {
			    const len = item.list.length
			    groupRecord.push(len)
			    flatItems.push(...item.list)
			  })
			  return { flatItems, groupRecord }
			},
			async signAll1(){
				if (await this.isDebounce()) return;
				if (!this.nextToken) {
					this.$confirm('使用完整功能，请登录使用！', '提示', {
						confirmButtonText: '去登录',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.$router.push({
							path: '/login',
							// query: {
							//   id: 1,
							// },
						})
					}).catch(() => {
				
					});
					return
				}
				const {flatItems,groupRecord} = this.flatTree(this.meetlist)
				let mySchoolMeeting = await this.getMySchoolMeeting()
				let idList = []
				
				mySchoolMeeting.forEach((item, index, arr) => {
					idList.push(item.id)
				})
				
				let selectMeetList = this.selectList1
				
				let meetingIdList = []
				let meeting_price = 0
				let allNameList = []
				let isOther = true
				selectMeetList.forEach((item, index, arr) => {
					if (item.meeting_status != 6) {
						meeting_price += Number(item.meeting_price)
						allNameList.push(item.meeting_name)
						isOther = false
					}
					meetingIdList.push(item.id)
				})
				if (meetingIdList.length == 0) {
					this.$message({
						message: '暂未选择双选会',
						type: 'error',
					})
					return
				}
				if (meetingIdList.length < 2) {
					this.$message({
						message: '批量报名至少需选择两场 ',
						type: 'error',
					})
					return
				}
				let obj = {
					meetId: meetingIdList,
					meeting_address: '',
					pdf_url: '',
					meeting_name: '批量报名' + allNameList.length + '场双选会，（' + allNameList.join('，') + '）',
					sign_time: '',
					meeting_price: meeting_price,
					isBatch: true,
					isOther: isOther
				}
				console.log(obj)
				
				
				
				
				sessionStorage.setItem('meetObj', JSON.stringify(obj))
				sessionStorage.setItem('selectMeetList', JSON.stringify(selectMeetList))
				this.$router.push({
					path: '/signup',
					// query: {
					//   id: 1,
					// },
				})
			},
			getSelectNum(){
				const {flatItems,groupRecord} = this.flatTree(this.meetlist)
				this.selectMeetList1 = flatItems.filter((item,index,arr)=>{
					return item.isSelect == true
				})
				
				// const currIdList = flatItems.map(v => v.id);
				  flatItems.forEach(row => {
				    const idx = this.selectIds.indexOf(row.id);
				    if (row.isSelect) {
				      if (idx === -1) {
				        this.selectList1.push({ ...row });
				        this.selectIds.push(row.id);
				      }
				    } else {
				      if (idx > -1) {
				        this.selectList1.splice(idx, 1);
				        this.selectIds.splice(idx, 1);
				      }
				    }
				  });
				
				let meeting_price = 0
				let meeting_num = 0
				this.selectList1 .forEach((item, index, arr) => {
					if(item.isSelect){
						meeting_price += Number(item.meeting_price)
						meeting_num++
					}
				})
				this.meeting_num = meeting_num
				this.meeting_price = meeting_price
			},
			itemSelect(item,index,itm,idx){
				let isSelect = true
				this.meetlist[index].list.forEach((itm,idx,array)=>{
					if ((itm.meeting_status == 1 || itm.meeting_status == 6) && !this.idList.includes(itm.id)) {
						if(!itm.isSelect){
							isSelect = false
						}
					}
				})
				this.meetlist[index].isSelect = isSelect
				this.getSelectNum()
			},
			someSelect(index,item){
				if(this.meetlist[index].isSelect){
					this.meetlist[index].list.forEach((itm,idx,array)=>{
						if ((itm.meeting_status == 1 || itm.meeting_status == 6) && !this.idList.includes(itm.id)) {
							itm.isSelect = true
						}
					})
				}else{
					this.meetlist[index].list.forEach((itm,idx,array)=>{
							itm.isSelect = false
					})
				}
				this.getSelectNum()
			},
			allSelect(){
				if(this.allChecked){
					this.meetlist.forEach((item,index,arr)=>{
						item.list.forEach((itm,idx,array)=>{
							if ((itm.meeting_status == 1 || itm.meeting_status == 6) && !this.idList.includes(itm.id)) {
								itm.isSelect = true
								item.isSelect = true
							}
						})
					})
				}else{
					this.meetlist.forEach((item,index,arr)=>{
						item.list.forEach((itm,idx,array)=>{
							itm.isSelect = false
							item.isSelect = false
						})
					})
				}
				this.getSelectNum()
			},
			selectable2(item, index){
				let boolean = true
				item.list.forEach((item,index,arr)=>{
					if ((item.meeting_status == 1 || item.meeting_status == 6) && !this.idList.includes(item.id)) {
						boolean = false
					}
				})
				return boolean
			},
			selectable1(row, index) {
				if ((row.meeting_status == 1 || row.meeting_status == 6) && !this.idList.includes(row.id)) {
					return false
				} else {
					return true
				}
			
			},
			
			toJobShadowing() {
				if (!this.nextToken) {
					this.$confirm('使用完整功能，请登录使用！', '提示', {
						confirmButtonText: '去登录',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.$router.push({
							path: '/login',
							// query: {
							//   id: 1,
							// },
						})
					}).catch(() => {

					});
					return
				}
				this.$router.push({
					path: '/jobShadowing',
				})
			},
			toWednesday() {
				if (!this.nextToken) {
					this.$confirm('使用完整功能，请登录使用！', '提示', {
						confirmButtonText: '去登录',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.$router.push({
							path: '/login',
							// query: {
							//   id: 1,
							// },
						})
					}).catch(() => {

					});
					return
				}
				this.$router.push({
					path: '/wednesday',
				})
			},
			toCooperation() {
				if (!this.nextToken) {
					this.$confirm('使用完整功能，请登录使用！', '提示', {
						confirmButtonText: '去登录',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.$router.push({
							path: '/login',
							// query: {
							//   id: 1,
							// },
						})
					}).catch(() => {

					});
					return
				}
				this.$router.push({
					path: '/cooperation',
				})
			},
			applyChange(val) {
				console.log(val)
				if(val){
					this.gradation.forEach((item, index, arr) => {
						item.isSelect = false
					})
					this.gradation[0].isSelect = true
				}
			},
			handleSizeChange(val) {
				this.pageSizes = val
				this.currentpage = 1
				this.getmyJobList()
			},
			onLine() {

				// this.dialogVisible = true
				this.handleQrcode()
			},
			handleQrcode(row) {
				// if (!this.nextToken) {
				// 	this.$confirm('使用完整功能，请登录使用！', '提示', {
				// 		confirmButtonText: '去登录',
				// 		cancelButtonText: '取消',
				// 		type: 'warning'
				// 	}).then(() => {
				// 		this.$router.push({
				// 			path: '/login',
				// 			// query: {
				// 			//   id: 1,
				// 			// },
				// 		})
				// 	}).catch(() => {

				// 	});
				// 	return
				// }
				// this.getQrcode(row.admin_id)
				this.dialogVisible = true
				// &is_test=1
				this.$util.post(
					`admin/home/qrcode?app_type=10&not_login=1&page_path=pages/courseware/meeting&id=${row.id}&is_test=${config.IS_TEST}`, {

					},
					(res) => {
						if (res.code == 200) {
							this.qrcodeImg = res.data.qrCode
							// this.sceneId = res.data.scene
							// this.setTimer()
							// localStorage.setItem('qrcodeImg', res.data.qrCode)
						}
					}
				)
			},
			offline(row) {
				if (row.stand_position_url) {
					window.open(row.stand_position_url, '_blank')
				}
			},
			// 防抖处理
			isRequest(duration = 3000) {
				if (this.request) return true
				this.request = true
				setTimeout(() => {
					this.request = false
				}, duration)
				return false
			},
			selectProvince(index) {
				this.currentpage = 1
				if (index == 0) {
					this.majors.forEach((item, index, arr) => {
						item.isSelect = false
					})
					this.majors[0].isSelect = true
				} else {
					this.majors[0].isSelect = false
					this.majors[index].isSelect = !this.majors[index].isSelect
					let bol = false
					this.majors.forEach((item, index, arr) => {
						if (item.isSelect == true) {
							bol = true
						}
					})
					if (!bol) {
						this.majors[0].isSelect = true
					}
				}
				if (this.searchName == '') {
					this.searchName1 = ''
				}
				this.getmyJobList()
			},

			async selectgradation(index) {
				if (await this.isDebounce()) return;
				if(this.isApply){
					this.$message({
						message: '按线路选择暂不支持层次筛选',
						type: 'warning',
					})
					return
				}
				this.currentpage = 1
				if (index == 0) {
					this.gradation.forEach((item, index, arr) => {
						item.isSelect = false
					})
					this.gradation[0].isSelect = true
				} else {
					this.gradation[0].isSelect = false
					this.gradation[index].isSelect = !this.gradation[index].isSelect
				}

				let bol = false
				this.gradation.forEach((item, index, arr) => {
					if (item.isSelect == true) {
						bol = true
					}
				})
				if (!bol) {
					this.gradation[0].isSelect = true
				}
				if (this.searchName == '') {
					this.searchName1 = ''
				}
				this.getmyJobList()
			},


			selecttypeList(index) {
				this.typeList.forEach((item, index, arr) => {
					item.isSelect = false
				})
				this.typeList[index].isSelect = true
			},
			selectexpense(index) {
				this.expense.forEach((item, index, arr) => {
					item.isSelect = false
				})
				this.expense[index].isSelect = true
			},

			tableRowClassName({
				row,
				rowIndex
			}) {
				if (row.id == this.meeting_id) {
					console.log(row)
					console.log(rowIndex)
					return 'warning-row';
				}
			},
			selectable(row, index) {
				if ((row.meeting_status == 1 || row.meeting_status == 6) && !this.idList.includes(row.id)) {
					return true
				} else {
					return false
				}

			},
			towebsite(row) {
				console.log(row)
				if (row.meeting_status == 5) {
					if (!row.website || row.website == '暂未公布') {
						this.$message.warning('暂未公布官网报名链接！');
					} else {
						window.open(row.website)
					}
				}

			},

			towebsite1() {
				if (row.meeting_status == 6) {
					if (!row.website || row.website == '暂未公布') {
						this.$message.warning('暂无缴费链接！');
					} else {
						window.open(row.website)
					}
				}
			},
			handleClick1(row) {

				if (!this.nextToken) {
					this.$confirm('使用完整功能，请登录使用！', '提示', {
						confirmButtonText: '去登录',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.$router.push({
							path: '/login',
							// query: {
							//   id: 1,
							// },
						})
					}).catch(() => {

					});
					return
				}

				console.log(row)
				this.getQrcode1(row.id, row)
				this.dialogVisible1 = true
				// this.$router.push({
				// 	path: "/jobDetails",
				// 	// query: {
				// 	//   id: 1,
				// 	// },
				// });
			},
			getQrcode1(id, scope) {
				// &is_test=1
				this.$util.post(
					`admin/home/qrcode?app_type=10&not_login=1&page_path=pages/courseware/meeting&id=${id}&is_test=${config.IS_TEST}`, {
						// app_type: 10,
						// page_path: 'pages/recruit/jobdetail',
						// id:id
					},
					(res) => {
						if (res.code == 200) {
							this.qrcodeImg1 = res.data.qrCode

							// this.sceneId = res.data.scene
							// this.setTimer()
							// localStorage.setItem('qrcodeImg', res.data.qrCode)
						}
					}
				)
			},
			closeElDialog1() {
				this.dialogVisible1 = false
			},
			beforeUpload() {},
			handleAvatarSuccess1(res, file) {
				console.log(res)
				if (res.code == 200) {
					this.resmessage = res.data
					this.$message({
						message: '上传成功',
						type: 'success',
					})
				} else {
					this.$message({
						showClose: true,
						message: file.response.msg,
						type: 'error',
					})
				}
			},
			addEnterprise() {
				this.importData = true
			},
			download1() {
				location.href = 'https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2025/06/18/obrfctzaoq3jiiqz.xlsx'
			},
			reset() {
				this.job_type = ''
				this.job_num = ''
				this.salary_min = ''
				this.salary_max = ''
				this.education = ''

				this.searchObj = {}
				this.getmyJobList()
			},
			setJobNum(val) {
				if (val == '') {
					this.job_num = ''
				} else if (val < 1) {
					this.job_num = 1
				}
			},
			getQrcode(id) {
				// &is_test=1
				this.$util.post(
					`admin/home/qrcode?app_type=10&not_login=1&page_path=pages/recruit/jobdetail&id=${id}&is_test=${config.IS_TEST}`, {
						// app_type: 10,
						// page_path: 'pages/recruit/jobdetail',
						// id:id
					},
					(res) => {
						if (res.code == 200) {
							this.qrcodeImg = res.data.qrCode
							// this.sceneId = res.data.scene
							// this.setTimer()
							// localStorage.setItem('qrcodeImg', res.data.qrCode)
						}
					}
				)
			},
			selectAll(selection) {
				console.log(selection)
				let selectMeetList = JSON.parse(JSON.stringify(this.selectMeetList))
				if (selection.length > 0) {

					const ids = selectMeetList.map(item => item.id);
					selection.forEach((item, index, arr) => {
						if (!ids.includes(item.id)) {
							selectMeetList.push(item)
						}
					})

				} else {
					const ids = this.meetlist.map(item => item.id);
					selectMeetList = selectMeetList.filter(item => {
						return !ids.includes(item.id);
					});
				}
				console.log(selectMeetList)
				this.selectMeetList = selectMeetList
			},


			handleSelectionChange(selection, row) {
				let selectIndex = -1
				let selectMeetList = JSON.parse(JSON.stringify(this.selectMeetList))
				selectMeetList.forEach((item, index, arr) => {
					if (item.id == row.id) {
						selectIndex = index
					}
				})
				if (selectIndex == -1) {
					selectMeetList.push(row)
				} else {
					selectMeetList.splice(selectIndex, 1)
				}
				this.selectMeetList = selectMeetList
				// this.selectMeetList = val
				// let selectMeetList = this.selectMeetList.filter((item, index, arr) => {
				// 	return item.meeting_status == 1 && !this.idList.includes(item.id)
				// })
				// let meetingIdList = []
				// let meeting_price = 0
				// selectMeetList.forEach((item, index, arr) => {
				// 	meeting_price += Number(item.meeting_price)
				// 	meetingIdList.push(item.id)
				// })

				// this.num = meetingIdList.length
				// this.meetingALLPrice = meeting_price
			},

			changeSalay1(val) {
				this.salary_max = ''
				if (val == 0) {
					this.isshow = false
				} else {
					this.isshow = true
				}
				let arr = []
				let array = JSON.parse(JSON.stringify(this.salaryArry3))
				arr = array.filter((item) => {
					return item.value > val
				})
				this.salaryDisabled = false
				this.salaryArry2 = arr
			},
			cancel() {
				this.dialogVisibleMultipleChoice4 = false
			},
			multiple4(val) {
				console.log(val)
				if (val.length > 0) {
					this.province_name = val.toString()
				} else {
					this.province_name = ''
				}

				this.dialogVisibleMultipleChoice4 = false
				this.academy_feature = val
				this.currentpage = 1
				this.getmyJobList()
				// this.getUserRecordList()
			},


			multipleClose() {
				this.multipleChange = false
			},
			searchWord(val) {
				this.college_type_list = val
			},
			handleClose(done) {
				done()
			},
			multipleOpen() {
				this.multipleChange = true
			},

			search() {
				// job_num
				// if(this.job_num>10000)
				let obj = {
					job_type: this.job_type,
					job_num: this.job_num,
				}
				if (this.salary_min == 0) {
					obj.salary_min = 0
					obj.salary_max = 0
				} else {
					obj.salary_min = this.salary_min
					obj.salary_max = this.salary_max
				}
				if (this.education !== '') {
					obj.education = JSON.stringify(this.education)
				}

				this.searchObj = obj
				this.currentpage = 1
				this.searchName1 = this.searchName
				this.getmyJobList()
				// this.$message({
				// 	message: '加载成功',
				// 	type: 'success'
				// });
			},
			selectcityBox3() {
				this.dialogVisibleMultipleChoice4 = true
			},
			changeMeeting(val) {
				// this.headIndex = val
				this.currentpage = 1
				this.getmyJobList()
				console.log('val', val)
			},
			changeIsFree(val) {
				console.log(val)
				this.currentpage = 1
				this.getmyJobList()
			},
			changeMeetingLevel(val) {
				console.log(val)
				// this.headIndex = val
				// this.getmyJobList()

				if (val === '全部') {
					this.shcool_level = ''
				} else {
					this.shcool_level = JSON.stringify([val])
				}
				this.currentpage = 1
				this.getmyJobList()
				console.log('val', val)
			},
			changeMeetingStatus() {
				this.getmyJobList()
			},
			getDaysUntilNextYear(days) {
				const now = new Date() // 当前日期和时间
				const standardStr = days.replace('年', '/').replace('月', '/').replace('日', '')
				const nextYear = new Date(standardStr) // 明年的同一天
				const diffTime = nextYear.getTime() - now.getTime() // 获取两个日期的毫秒差
				const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) // 将毫秒转换为天数
				return diffDays
			},
			// load() {
			// 	this.currentpage += 1
			// 	console.log(789451)
			// },
			
			getmyJobList() {
				this.loading = true
				let searchName = this.searchName1.replace(/%/g, '');
				let selectMeetList = []
				if (this.selectMeetList.length > 0) {
					selectMeetList = JSON.parse(JSON.stringify(this.selectMeetList))
				}

				console.log('shcool_level', this.shcool_level)
				let meetingStatus = -1
				if (this.meetingStatus == '报名中') {
					meetingStatus = 1
				} else if (this.meetingStatus == '进行中') {
					meetingStatus = 1
				} else if (this.meetingStatus == '已结束') {
					meetingStatus = -1
				}

				let province_name = []
				this.majors.forEach((item, index, arr) => {
					if (item.isSelect) {
						if (item.name == '全部') {
							province_name = []
						} else {
							province_name.push(item.name)
						}
					}
				})

				let school_type = []
				this.gradation.forEach((item, index, arr) => {
					if (item.isSelect) {
						if (item.name == '全部') {
							school_type = []
						} else {
							school_type.push(item.name)
						}
					}
				})
				if (school_type == '全部') {
					school_type = ''
				}

				let obj = {
					page: this.currentpage,
					province_name_arr: JSON.stringify(province_name) || '',
					school_type: JSON.stringify(school_type) || '',
					meeting_name: searchName,
					meeting_status: meetingStatus,
					pageSize: this.pageSizes,
					meeting_id: this.meeting_id,
					admin_id:this.schoolInfo.admin_id,
					reg_status:-1,
					// is_charge: -1,
					meeting_cat: -1,
					is_demo: 2
				}
				// if (this.is_demo == 2) {
				// 	obj.is_demo = this.is_demo
				// } else {
				// 	obj.is_demo = 1
				// }
				if (this.isFree == '不限') {

				} else if (this.isFree == '是') {
					obj.is_charge = 1
				} else {
					obj.is_charge = 0
				}
				if (this.headIndex) {
					obj.meeting_cat = this.headIndex
				}
				console.log('shcool_level', this.shcool_level)
				let that = this
				this.$util.get('v2/getMeetListByLine', obj, async (res) => {
					if (res.code === 200) {
						// if (this.page == 1) {
							console.log(res.data)
							if(res.data.length>0){
								let meetlist = res.data
								meetlist.forEach((item,index,arr)=>{
									arr[index].isSelect = false
									item.list.forEach((itm,idx,array)=>{
										array[idx].isSelect = false
										if(itm.reg_end_time){
											itm.sDay = that.getDaysUntilNextYear('2026年' + itm.reg_end_time)
										} else {
											itm.sDay = that.getDaysUntilNextYear('2026年' + itm.meeting_time)
										}
									})
								})
								
								meetlist.forEach((item,index,arr)=>{
									let isSelect = true
									item.list.forEach((itm,idx,array)=>{
										if (this.selectIds.includes(itm.id)) {
											array[idx].isSelect = true
										}
										if ((itm.meeting_status == 1 || itm.meeting_status == 6) && !this.idList.includes(itm.id)) {
											if(!itm.isSelect){
												isSelect = false
											}
										}
									})
									item.isSelect = isSelect
								})
								this.meetlist = meetlist
								this.loading = false
								let mySchoolMeeting = await that.getMySchoolMeeting()
								let idList = []
								mySchoolMeeting.forEach((item, index, arr) => {
									idList.push(item.id)
								})
								this.idList = idList
								// this.idList = [3583, 3312, 3333, 3334, 3332, 3329, 3330, 3328, 3271, 3266, 3268, 3324,3326,3327,3331]
								meetlist.forEach((item,index,arr)=>{
									item.list.forEach((itm,idx,array)=>{
										if (idList.includes(itm.id)) {
											array[idx].registered = true
										}else{
											array[idx].registered = false
										}
									})
								})
								
								that.meetlist = meetlist
								
							}
							this.loading = false
							
							return
							
						if (res.data.data.length > 0) {
							console.log('res.data.data', 11111111111111)
							res.data.data.forEach((item) => {
								if (item.reg_end_time) {
									item.sDay = that.getDaysUntilNextYear('2026-' + item.reg_end_time)
								} else {
									item.sDay = that.getDaysUntilNextYear('2026-' + item.meeting_time)
								}
								// item.meeting_status = '1'
							})
							

							this.meetlist = res.data.data
							this.loading = false

							let mySchoolMeeting = await that.getMySchoolMeeting()
							let meetlist = res.data.data
							console.log(mySchoolMeeting)
							let idList = []
							mySchoolMeeting.forEach((item, index, arr) => {
								idList.push(item.id)
							})
							
							this.idList = idList
							meetlist.forEach((item, index, arr) => {
								if (idList.includes(item.id)) {
									arr[index].registered = true
								}
							})
							// meetlist[0].meeting_status = 5

							// let meetlist1 = []
							// if (this.shcool_level) {
							// 	meetlist1 = meetlist.filter((item) => {
							// 		return this.shcool_level.indexOf(item.school_type) > -1
							// 	})
							// } else {
							// 	meetlist1 = meetlist
							// }
							this.meetlist = meetlist1

							this.$nextTick(() => {
								if (this.selectMeetList.length > 0) {
									// meetlist1.
									// selectMeetList
									let selectMeetIds = []
									selectMeetList.forEach((item, index, arr) => {
										selectMeetIds.push(item.id)
									})

									console.log(selectMeetIds)
									meetlist1.forEach((item, index, arr) => {
										if (selectMeetIds.includes(item.id)) {
											console.log(item)
											this.$refs.multipleTable.toggleRowSelection(item);
										}
									})
								}
							})

						} else {
							this.isnextPage = false
							this.meetlist = []
						}
					} else {
						this.isnextPage = false
					}
					this.total = res.data.total

				}, (err) => {
					console.log(err)
					this.loading = false
				})
			},
			
			
			$getTime(symbol = '-', status = 0, time = Date.now()) {
				let date = new Date(time)
				let Y = date.getFullYear() + symbol

				let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + symbol
				let D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' '

				let H = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
				let Minu = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':'
				let S = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
				switch (status) {
					case 0:
						return Y + M + D
					case 1:
						return Y + M + D + H + Minu + S
					default:
						break
				}
			},
			getTime(dateTimeString) {
				const dateTime = new Date(dateTimeString)
				const year = dateTime.getUTCFullYear()
				const month = String(dateTime.getUTCMonth() + 1).padStart(2, '0')
				const day = String(dateTime.getUTCDate()).padStart(2, '0')
				// const hour = String(dateTime.getUTCHours()).padStart(2, '0');
				// const minute = String(dateTime.getUTCMinutes()).padStart(2, '0');
				// const second = String(dateTime.getUTCSeconds()).padStart(2, '0');

				const formattedDateTime = `${year}-${month}-${day}`

				return formattedDateTime
			},
			isRequest(duration = 2000) {
				if (this.request) return true
				this.request = true
				setTimeout(() => {
					this.request = false
				}, duration)
				return false
			},
			postPosition() {
				if (!this.nextToken) {
					this.$confirm('使用完整功能，请登录使用！', '提示', {
						confirmButtonText: '去登录',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.$router.push({
							path: '/login',
							// query: {
							//   id: 1,
							// },
						})
					}).catch(() => {

					});
					return
				}
				this.$router.push({
					path: '/reglist',
					// query: {
					//   id: 1,
					// },
				})
			},
			isDebounce(duration = 500) {
				return new Promise(resolve => {
					// 如果已有定时器，清除（重新计时）
					if (this.timer) {
						clearTimeout(this.timer);
					}
					// 开启新定时器
					this.timer = setTimeout(() => {
						resolve(); // 时间到 → 放行
					}, duration);
				});
			},
			async signAll() {
				if (await this.isDebounce()) return;
				if (!this.nextToken) {
					this.$confirm('使用完整功能，请登录使用！', '提示', {
						confirmButtonText: '去登录',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.$router.push({
							path: '/login',
							// query: {
							//   id: 1,
							// },
						})
					}).catch(() => {

					});
					return
				}
				if (this.isRequest()) return false
				let mySchoolMeeting = await this.getMySchoolMeeting()
				let idList = []

				mySchoolMeeting.forEach((item, index, arr) => {
					idList.push(item.id)
				})
				let selectMeetList = this.selectMeetList.filter((item, index, arr) => {
					return (item.meeting_status == 1 || item.meeting_status == 6) && !idList.includes(item.id)
				})
				console.log(selectMeetList)
				let meetingIdList = []
				let meeting_price = 0
				let allNameList = []
				let isOther = true
				selectMeetList.forEach((item, index, arr) => {
					if (item.meeting_status != 6) {
						meeting_price += Number(item.meeting_price)
						allNameList.push(item.meeting_name)
						isOther = false
					}
					meetingIdList.push(item.id)
				})
				if (meetingIdList.length == 0) {
					this.$message({
						message: '暂未选择双选会',
						type: 'error',
					})
					return
				}
				if (meetingIdList.length < 2) {
					this.$message({
						message: '批量报名至少需选择两场 ',
						type: 'error',
					})
					return
				}
				let obj = {
					meetId: meetingIdList,
					meeting_address: '',
					pdf_url: '',
					meeting_name: '批量报名' + allNameList.length + '场双选会，（' + allNameList.join('，') + '）',
					sign_time: '',
					meeting_price: meeting_price,
					isBatch: true,
					isOther: isOther
				}
				console.log(obj)
				sessionStorage.setItem('meetObj', JSON.stringify(obj))
				sessionStorage.setItem('selectMeetList', JSON.stringify(this.selectMeetList))
				this.$router.push({
					path: '/signup',
					// query: {
					//   id: 1,
					// },
				})
			},
			toSign(scope) {

				if (!this.nextToken) {
					this.$confirm('使用完整功能，请登录使用！', '提示', {
						confirmButtonText: '去登录',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.$router.push({
							path: '/login',
							// query: {
							//   id: 1,
							// },
						})
					}).catch(() => {

					});
					return
				}

				let item = scope
				console.log('id', item)
				let obj = {
					meetId: item.id,
					school_name: item.school_name || '',
					lat: item.work_lat || '',
					lng: item.work_lng || '',
					meeting_address: item.meeting_address || '',
					pdf_url: item.pdf_url || '',
					meeting_name: item.meeting_name || '',
					sign_up_img: item.sign_up_img || '',
					sign_time: item.meeting_time + ' ' + item.meeting_hour,
					meeting_price: item.meeting_price == '0' ? '' : item.meeting_price,
					isBatch: false,
					isOther: false
				}

				if (scope.meeting_status == 6) {
					obj.isOther = true
					obj.meeting_price = ''
				}

				sessionStorage.setItem('meetObj', JSON.stringify(obj))
				// this.$uniapp.goPage(`/pages/service/signup?meetId=${item.id}&school_name=${item.school_name||''}&lat=${item.work_lat||''}&lng=${item.work_lng||''}&meeting_address=${item.meeting_address||''}&pdf_url=${item.pdf_url || ''}&meeting_name=${item.meeting_name||''}&sign_up_img=${item.sign_up_img}`)
				// sessionStorage.setItem('user', JSON.stringify({ name: 'Alice', id: 123 }));

				this.$router.push({
					path: '/signup',
					// query: {
					//   id: 1,
					// },
				})
			},
			handleClick(row) {
				this.getQrcode(row.id)
				this.dialogVisible = true
				// this.$router.push({
				// 	path: "/jobDetails",
				// 	// query: {
				// 	//   id: 1,
				// 	// },
				// });
			},
			beforeClose() {},
			closeElDialog() {
				this.dialogVisible = false
			},

			currentChange(page) {
				console.log(page)
				this.currentpage = page
				// this.currentpage = page
				// this.getEnterpriseList()
				this.getmyJobList()
			},
			previousPage() {
				if (this.currentpage > 1) {
					this.currentpage = this.currentpage - 1
					this.getmyJobList()
				}
			},
			nextPage() {
				if (!this.isNextPage) {
					this.currentpage++
					this.getmyJobList()
				}
			},
			getMySchoolMeeting() {
				return new Promise((resolve, reject) => {
					let obj = {
						admin_id: this.schoolInfo.admin_id,
					}
					this.$util.post('v2/school_job/getMySchoolMeeting', obj, (res) => {
						if (res.code === 200) {
							this.regLength = res.data.length
							resolve(res.data)
						} else {
							resolve([])
						}
					})
				})
			},

		},
	}
</script>
<style lang="less">
	// #meeting .tableContainer 
	#meeting .tableHeader .el-checkbox__inner {
		border: 1px solid #409EFF !important;
	}

	#meeting .signAll {
		background: #FF6600 !important;
		border-color: #FF6600 !important;

	}

	#meeting .el-upload-dragger {
		width: 720px !important;
	}

	#meeting .searchContainer .el-select {
		min-width: 120px !important;
		width: 100% !important;
		/* max-width: 265px !important; */
	}

	#meeting.el-table .el-table__cell {
		padding: 10px 0 !important;

	}

	#meeting.header-row-class-name {
		.cell {
			font-size: 14px !important;
			font-size: bold !important;

			transform: scale(1.03);
		}

	}

	/* #positionManagement .searchContainer .el-input__inner {
		background-color: #F0F4FA !important;
		color: #000;
	}
	
	#positionManagement .searchContainer .el-tag.el-tag--info {
		background: #fff !important;
		border-color: #fff;
	}
	
	#positionManagement .searchContainer .el-input__inner::-moz-placeholder {
		color: #000;
	}
	
	#positionManagement .searchContainer .el-input__inner::-ms-input-placeholder {
		color: #000;
	}
	
	#positionManagement .searchContainer .el-input__inner::-webkit-input-placeholder {
		color: #000;
	} */

	#meeting .searchContainer .el-date-editor {
		min-width: 175px !important;
		/* max-width: 265px !important; */
	}

	#meeting .has-gutter .el-checkbox {
		// display: none !important;
	}

	#meeting .searchContainer .el-date-editor {
		min-width: 175px !important;
		/* max-width: 265px !important; */
	}

	#meeting .searchContainer .el-input {
		min-width: 120px !important;
		/* max-width: 265px !important; */
	}

	#meeting .el-table .cell {
		text-align: center !important;
		// font-weight:bold !important;
		// font-size: 16px !important;
	}

	#meeting .el-table__header th {
		background: #e9eeff;
		font-weight: bold !important;
		color: #2a2929 !important;
	}

	#meeting .el-table__body td {
		background: #f9fbff;
	}

	/* .tableContainer .compile .el-button--primary {
		background-color: #4F8FF0;
		border-color: #4F8FF0;
	} */

	.tableContainer .delete .el-button--primary {
		background-color: #dc7777;
		border-color: #dc7777;
	}

	#meeting .preview .el-dialog {
		background: initial;
		box-shadow: initial;
	}


	#meeting .warning-row td {
		background: #1d2646;
	}

	#meeting .warning-row .item-main-box .item-right .item-1 {
		color: #ffffff;
	}

	#meeting .warning-row .holdingTime {
		color: #ffffff;
	}

	#meeting .warning-row .meettype {
		color: #ffffff !important;
	}

	#meeting .warning-row .item-1 {
		color: #ffffff !important;
	}

	#meeting .warning-row .deadline {
		color: #ffffff !important;

	}

	#meeting .warning-row .compile {
		width: 80px !important;
		color: #000000 !important;
		background: #cad6ff !important;
		opacity: 1 !important;
		text-align: center !important;
		padding: 10px 0 !important;
	}

	#meeting .compile {
		width: 80px !important;
		text-align: center !important;
		padding: 10px 0 !important;

	}

	#meeting .warning-row .payFees {
		width: 100% !important;
		color: #9db3fe !important;
		background-color: #1d2646 !important;
		border-color: #1d2646 !important;
		font-weight: 600;
		// cursor:pointer;
	}

	#meeting .warning-row .payFees1 {
		width: 100% !important;
		color: #ffffff;
		background-color: #1d2646 !important;
		border-color: #1d2646 !important;
		font-weight: 600;
		// cursor:pointer;
	}

	#meeting .payFees {
		width: 100% !important;
		color: #000000;
		background-color: #f9fbff !important;
		border-color: #f9fbff !important;
		cursor: auto;
	}
</style>
<style lang="less" scoped>
	.container {
		width: 100%;
		position: relative;

		.headerContainer {
			width: 100%;
			padding: 20px 0 20px 0;
			border-bottom: 1px solid #eeeeee;
			display: flex;
			align-items: center;
			margin-bottom: 25px;

			.title {
				margin-right: 20px;
				font-weight: bold;
				font-size: 16px;
				color: #333;
			}

			.el-button--primary {
				font-size: 14px !important;
				// background-color: #0084FF !important;
				// border-color: #0084FF !important;
			}
		}

		.sortContainer {
			padding: 0 40px;
			// width: calc(100vw - 210px);
			box-sizing: border-box;

			.screenContainer {
				display: flex;
				// align-items: center;
				margin-bottom: 10px;
				margin-top: 10px;
			}

			.searchContainer {
				flex: 1;
				// padding-left: 8px;
				// display: flex;
				// align-items: center;
				// flex-wrap: wrap;

				// display: grid;
				// grid-template-columns: repeat(4, 1fr);
				// grid-gap: 10px 10px;
				margin-right: 10px;

				// .searchItem {
				// 	// flex: 1;
				// 	// width: 100%;
				// 	display: flex;
				// 	align-items: center;
				// 	// margin-right: 10px;
				// 	// margin-bottom: 10px;

				// 	.iptName {
				// 		// width:100px;
				// 		text-align: left;
				// 		font-weight: 400;
				// 		font-size: 14px;
				// 		color: #333;
				// 		padding-right: 5px;
				// 		white-space: nowrap;
				// 		// min-width: 100px;
				// 	}

				// 	.iptName1 {
				// 		// margin-left: 10px;
				// 	}
				// }

				.screenItem {
					display: flex;
					align-items: baseline;

					.left {
						width: 30px;
						font-weight: 400;
						font-size: 14px;
						color: #000;
						margin-right: 8px;
						margin-left: 9px;
						font-weight: 600;
					}

					.right {
						flex: 1;
						display: flex;
						align-items: center;
						flex-wrap: wrap;


					}

					.item {
						font-weight: 400;
						font-size: 14px;
						color: #818080;
						padding: 1px 5px;
						border: 1px solid #ffffff;
						border-radius: 20px;
						margin: 0 3px 3px 0;

						cursor: pointer;
					}

					.active {
						border: 1px solid #1E40AF;
						color: #1E40AF;
					}
				}

			}

			.btnContainer {
				// width: 20%;
				display: flex;
				align-items: center;
				// padding-right: 15px;
				border: 1px solid #dcdfe6;
				// border-right: none;
				box-sizing: border-box;
				height: 39px;
				border-radius: 4px;
				padding-right: 10px;
				width: 260px;

				.searchLeft {
					// height: 39px;
					// width: 140px;
					flex: 1;
					display: flex;
					align-items: center;
					padding-left: 10px;
					box-sizing: border-box;

					img {
						width: 14px;
						height: 14px;
						margin-right: 4px;
					}

					input {
						// width: 120px;
						flex: 1;
						height: 35px;
						outline: none;
						border: none;
						margin: 0 10px;
					}

					input::placeholder {
						color: #606266;
						font-size: 14px;
						opacity: 0.6;
					}
				}

				.btn {
					// width: 70px;
					// height: 39px;
					width: 30px;
					display: flex;
					align-items: center;
					justify-content: center;
					// background: #fd8342;
					border-radius: 5px;
					font-size: 0;
					cursor: pointer;

					img {
						width: 16px;
						height: 16px;
						margin-right: 10px;
					}

					div {

						font-weight: 400;
						font-size: 14px;
						color: #004eff;
					}
				}
			}


		}

		.listContainer {
			padding: 0 40px;
			// padding: 0 40px;

			// .title {
			// 	font-weight: bold;
			// 	font-size: 18px;
			// 	color: #2D3C50;
			// 	margin-bottom: 20px;
			// 	margin-left: 8px;
			// }
			.tableContainer {
				width: 100%;
				// min-width: 1333px;
				// height: 602px;
			}

		}
	}

	.preview {
		.text {
			font-weight: 400;
			font-size: 14px;
			color: #2a2929;
			// margin-bottom: 5px;
		}

		.btn {
			font-weight: 400;
			font-size: 14px;
			color: #004eff;
			cursor: pointer;
		}
	}

	.paging {
		width: calc(100vw - 180px);;
		padding: 10px 77px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		z-index: 200;
		position: fixed;
		left: 180px;
		right: 0;
		bottom: 0;
		background: #ffffff;
		box-shadow: 0 0 10px rgba(0, 0, 0, .3);
		.pagingLeft {
			display: flex;
			align-items: center;
		}
	}

	.qrcodeContainer {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: center;

		.qrcode {
			padding: 50px 50px;
			// width: 410px;
			// height: 390px;
			background: #ffffff;
			border-radius: 10px;
			border: 4px solid #0084ff;

			display: flex;
			align-items: center;
			justify-content: center;
			flex-direction: column;
			font-size: 0;

			img {
				width: 208px;
				height: 208px;
				margin-bottom: 37px;
			}

			.hite1 {
				font-weight: bold;
				font-size: 16px;
				color: #333333;
				margin-bottom: 17px;
			}

			.hite2 {
				font-weight: 500;
				font-size: 16px;
				color: #333333;
			}
		}
	}

	.elDialog {
		position: relative;
		font-size: 0;

		.main {
			box-sizing: border-box;
			padding: 30px 50px 50px 50px;
			background: #ffffff;
			border-radius: 10px;

			.title {
				font-weight: bold;
				font-size: 16px;
				color: #2a2929;
				margin-bottom: 30px;
			}
		}

		.close {
			position: absolute;
			top: -28px;
			right: -28px;
			width: 32px;
			height: 32px;
			cursor: pointer;
		}
	}

	.companyInfo {
		width: 100%;
		padding: 20px 0 20px 0;
		border-bottom: 1px solid #eeeeee;
		font-size: 0;
		display: flex;
		align-items: center;
		margin-bottom: 5px;

		// img {
		// 	width: 57px;
		// 	height: 57px;
		// 	border-radius: 50%;
		// 	background: #003987;
		// 	margin-right: 10px;
		// }

		.companyInfoRight {
			display: flex;
			justify-content: center;
			flex-direction: column;

			.companyInfoName {
				font-weight: 500;
				font-size: 18px;
				color: #2d3c50;
				margin-bottom: 10px;
			}

			.tags {
				display: flex;
				align-items: center;

				.item {
					padding: 2px 4px;
					border-radius: 5px;
					border: 1px solid #aeaeae;
					font-weight: 500;
					font-size: 12px;
					color: #aeaeae;
					margin-right: 5px;
				}
			}
		}
	}

	.item-main-box {
		display: flex;

		img {
			width: 90px;
			height: 72px;
			border-radius: 2px;
		}

		.item-right {
			flex: 1;
			padding-left: 10px;
			box-sizing: border-box;

			.item-1 {
				text-align: left;
				// height: 38px;
				// line-height: 18px;
				color: #000000;
				font-weight: 600;
			}

			.item-2 {
				text-align: left;
				// margin-top: 20px;
				color: #000000;
				font-weight: 600;

				b {
					color: #1e68ff;
				}
			}
		}
	}

	.majorbox {
		flex: 1;
		// width: 165px;
		border-radius: 4px;
		border: 1px solid #dcdfe6;
		cursor: pointer;
		display: flex;
		align-items: center;
		padding: 0 10px 0 15px;
		font-size: 14px;
	}

	.majorbox:hover {
		border: 1px solid #c0c4cc;
	}

	.majorBox {
		// width: 200px;
		height: 40px;
		line-height: 40px;
		font-size: 14px;
		color: #6b7280;
		flex: 1;
	}




	.applyContainer {
		display: grid;
		grid-template-columns: repeat(3, 1fr);
		grid-gap: 10px 10px;
		margin-top: 10px;

		.item {
			display: flex;
			align-items: center;
			justify-content: space-between;
			background: #E3F7EE;
			padding: 20px 20px;
			border-radius: 10px;
			cursor: pointer;

			.left {
				.title {
					font-weight: 500;
					font-size: 16px;
					color: #333;
					margin-bottom: 5px;
				}

				.subheading {
					display: flex;
					align-items: center;
					font-size: 0;

					div {
						font-weight: 500;
						font-size: 14px;
						color: #999999;
						margin-right: 5px;
					}

					img {
						width: 15px;
						height: 15px;
					}
				}
			}

			.right {
				font-size: 0;

				img {
					width: 50px;
					height: 50px;
				}
			}
		}
	}





	.tableHeader {
		display: flex;
		align-items: center;
		width: 100%;
		height: 46px;
		background: #e9eeff;
		// padding: 0 15px 0 0;

		div {
			text-align: center;
			font-weight: bold;
			color: #2a2929;
			font-size: 14px;
			padding: 0 10px;
		}
	}

	.tableBody {
		min-height: 400px;
		// display: flex;
		// align-items: center;
		width: 100%;
		// height: 46px;
		background: #f9fbff;
		margin-bottom: 20px;
		.item {
			display: flex;
			align-items: center;
			padding: 12px 10px;
			// margin: 0 10px;
		}

		.checkboxContainer {
			justify-content: center;
			padding: 0 10px;
		}

		.jobfairname {
			font-size: 0;

			img {
				width: 90px;
				height: 72px;
				margin-right: 10px;
			}

			.item-1 {
				text-align: left;
				color: #000000;
				font-weight: 600;
				font-size: 14px;
			}
		}

		.holdingTime {
			color: #333;
			font-weight: 600;
			font-size: 14px;
			word-break: break-all;
		}

		.assemblyRoom {
			font-size: 14px;
		}

		.cutOff {
			font-size: 14px;
			font-weight: 600;
			color: #333;
			text-align: center;
		}

		.cost {
			text-align: center;
			font-size: 14px;
			font-weight: 600;
			color: #333;
		}
	}
</style>
<style>
	@supports (-webkit-touch-callout: none) {
	  .paging {
	    padding: 10px 57px;
	  }
	  }
</style>